"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Sync = /** @class */ (function () {
    function Sync() {
        this.hasSynced = false;
    }
    Sync.prototype.syncStart = function (opts) {
        this.type = opts ? opts.type : undefined;
        this.id = opts ? opts.id : undefined;
        this.startDate = new Date();
        this.endDate = undefined;
        this.error = undefined;
        this.syncing = true;
    };
    Sync.prototype.syncEnd = function () {
        this.hasSynced = true;
        this.endDate = new Date();
        if (!this.startDate) {
            this.startDate = this.endDate;
        }
        this.syncing = false;
    };
    Sync.prototype.syncError = function (error) {
        this.hasSynced = true;
        this.error = error;
        this.syncEnd();
    };
    Sync.prototype.clear = function () {
        this.type = undefined;
        this.id = undefined;
        this.startDate = undefined;
        this.endDate = undefined;
        this.error = undefined;
        this.syncing = false;
        this.hasSynced = false;
    };
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "startDate", void 0);
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "endDate", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Sync.prototype, "error", void 0);
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "syncing", void 0);
    __decorate([
        mobx_1.observable
    ], Sync.prototype, "hasSynced", void 0);
    __decorate([
        mobx_1.action
    ], Sync.prototype, "syncStart", null);
    __decorate([
        mobx_1.action
    ], Sync.prototype, "syncEnd", null);
    __decorate([
        mobx_1.action
    ], Sync.prototype, "syncError", null);
    __decorate([
        mobx_1.action
    ], Sync.prototype, "clear", null);
    return Sync;
}());
exports.Sync = Sync;
